export const isCCGActive = (id, filters) =>
  filters.includes(`consumerGroups: "${id}"`)
